import { SfmResource } from 'src/AppScopes/resource'
import type { SfmResourceProps } from 'src/AppScopes/resource'

import { Show } from './Show'

export function Resource(props: SfmResourceProps) {
  return <SfmResource {...props} show={Show} />
}
